import { getTenant } from '../../tenant-support/get-tenant';
import { IChatMessage, ICitation } from '../../hooks/ai-search/use-chat';

export function preprocessMessageContent(message: IChatMessage): IChatMessage {
  const tenantName = (() => {
    try {
      return getTenant().name;
    } catch (error) {
      console.error('Error getting tenant:', error);
      return '';
    }
  })();

  const processedContent = message.content ? message.content.replace(/__tenant_name__/g, tenantName) : message.content;

  const processedCitations = message.citations?.map(citation => ({
    ...citation,
    link: citation.link ? citation.link.replace(/__tenant_name__/g, tenantName) : citation.link,
  }));

  return {
    ...message,
    content: processedContent,
    citations: processedCitations,
  };
}
